import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import convertToCurrency from '../../../../_shared/utils/convertToCurrency';
import StyledNumberOfBids from '../../../Vdp/BidBox/Summary/NumberOfBids/Styles';
import { StyledCurrentBid } from '../../../Vdp/BidBox/History/BiddingStatus/Styles';
import { StyledCurrentBidWrapper, StyledNoBids } from './Styles';

const propTypes = {
  tradeSummary: PropTypes.shape({
    auctionSummary: PropTypes.shape({
      numBids: PropTypes.number
    })
  }).isRequired
};

// TODO: Add testId prop
const ActiveBids = ({ tradeSummary: { auctionSummary, id } }) => {
  if (auctionSummary?.numBids === 0) {
    return (
      <StyledNoBids data-testid={`active-list-no-bids-${id}`}>
        {/* No bids yet */}
        <FormattedMessage id="vdp.bid.noBids" />
      </StyledNoBids>
    );
  }

  if (auctionSummary?.numBids > 0) {
    return (
      <>
        <StyledNumberOfBids data-testid={`active-list-bid-counter-${id}`}>
          <b>
            <FormattedMessage
              id="vdp.bid.numberOfBids"
              values={{
                numberOfBids: auctionSummary?.numBids
              }}
            />
          </b>
        </StyledNumberOfBids>
        <StyledCurrentBidWrapper>
          <StyledCurrentBid data-testid={`active-list-current-bid-value-${id}`}>
            {convertToCurrency(auctionSummary?.maxBid)}
          </StyledCurrentBid>
        </StyledCurrentBidWrapper>
      </>
    );
  }

  return null;
};

ActiveBids.propTypes = propTypes;

export default ActiveBids;
